export default "__VITE_ASSET__CNC_JOJG__"